import { render, staticRenderFns } from "./TitreFiche.vue?vue&type=template&id=673ecb52&"
import script from "./TitreFiche.vue?vue&type=script&lang=js&"
export * from "./TitreFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports